<template>
  <v-menu left bottom min-width="200px" offset-y content-class="mt-2">
    <template v-slot:activator="{on}">
      <slot name="activator" :on="on"> </slot>
    </template>
    <z-card class="info-card" min-width="200px" width="100%">
      <template #content>
        <div class="text-center avatar-container">
          <z-avatar
            class="avatar"
            color="var(--primary)"
            size="42px"
            :name="avatarName"
            :photo="srcAvatar"
          />
          <div class="body-bold">{{ username }}</div>
          <div v-if="email" class="body3">
            {{ email }}
          </div>
        </div>
        <template v-if="company">
          <v-divider></v-divider>
          <div class="mx-auto text-center">
            <div class="body-text">{{ $t('company') }}</div>
            <div class="body-text">{{ company }}</div>
          </div>
        </template>
        <slot></slot>
        <v-divider></v-divider>
        <z-btn
          primary
          small
          rounded
          width="100%"
          :text="$t('logout')"
          @click="$emit('logout')"
        />
      </template>
    </z-card>
  </v-menu>
</template>

<script>
/**
 * Componente usado para exibir informações do usuário e realizar logout.
 *
 * @displayName User Menu
 *
 */
export default {
  name: 'ZUserMenu',
  props: {
    /**
     * Nome do usuário
     */
    username: {
      type: String,
      required: true,
    },
    /**
     * Empresa/Namespace do usuário
     */
    company: {
      type: String,
      required: true,
    },
    /**
     * Email do usuário
     */
    email: {
      type: String,
      required: true,
    },
    /**
     * Foto do avatar que deve ser usado
     */
    srcAvatar: {
      type: String,
      required: false,
    },
  },
  computed: {
    avatarName() {
      if (!this.username) return ''

      return this.username
        .split(' ')
        .map((word) => word.charAt(0))
        .slice(0, 2)
        .join('')
        .toUpperCase()
    },
  },
  i18n: {
    pt: {
      company: 'Empresa',
    },
    en: {
      company: 'Company',
    },
    es: {
      company: 'Empresa',
    },
    fr: {
      company: 'Société',
    },
    tr: {
      company: 'Şirket',
    },
  },
}
</script>

<style lang="scss" scoped>
.info-card {
  display: grid;
  row-gap: 15px;
  position: relative;
}

.avatar-container {
  display: grid;
  row-gap: 5px;
  justify-items: center;
}

.avatar {
  color: white;
}
</style>
